<template>
  <!-- news from the Platform's admin; stays on the main page until the psychologist closes it -->
  <div v-if="items.length" class="announcements">
    <div v-for="item in items" :key="item.id" class="announcements__item">
      <button type="button" class="announcements__close" aria-label="Закрити" :disabled="closingId === item.id" @click="close(item)">
        <v-icon>mdi-close</v-icon>
      </button>
      <div class="announcements__label">Повідомлення від Платформи</div>
      <div class="announcements__title">{{ item.title }}</div>
      <div class="announcements__text">{{ item.text }}</div>
      <div class="announcements__actions">
        <a v-if="item.button_url" :href="item.button_url" target="_blank" rel="noopener" class="announcements__btn">{{ item.button_text }}</a>
        <button type="button" class="announcements__ok" :disabled="closingId === item.id" @click="close(item)">Зрозуміло</button>
      </div>
    </div>
  </div>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "AnnouncementsCard",
  data() {
    return {
      items: [],
      closingId: null,
    };
  },
  mounted() {
    ApiClient.get("api/psychologists/me/announcements").then((response) => {
      if (response) this.items = response.data.data;
    });
  },
  methods: {
    close(item) {
      this.closingId = item.id;
      ApiClient.post(`api/psychologists/me/announcements/${item.id}/read`)
        .then((response) => {
          if (response) this.items = this.items.filter((other) => other.id !== item.id);
        })
        .finally(() => {
          this.closingId = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.announcements {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.announcements__item {
  position: relative;
  padding: 24px 56px 20px 24px;
  border-left: 4px solid #00a3b7;
  border-radius: 10px;
  background: #e0f4f6;
  color: #575756;
}
.announcements__close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 44px;
  height: 44px;
}
.announcements__label {
  margin-bottom: 4px;
  color: #00a3b7;
  font-size: 14px;
}
.announcements__title {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
}
.announcements__text {
  margin-top: 8px;
  font-size: 16px;
  line-height: 1.5;
  white-space: pre-line;
}
.announcements__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}
.announcements__btn,
.announcements__ok {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0 18px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 500;
}
.announcements__btn {
  background: #00a3b7;
  color: #ffffff !important;
  text-decoration: none;
}
.announcements__ok {
  border: 1px solid #00a3b7;
  color: #00a3b7;
}
@media (max-width: 600px) {
  .announcements__item {
    padding: 20px 48px 16px 16px;
  }
}
</style>
